import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_USER_AFS_LICENCES: (afsLicence) => ({ afsLicence }),
    API: {
      GET_USER_AFS_LICENCES: apiResourceActionCreator('afsLicences')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.AfsLicences), authToken, actions.user.api.getUserAfsLicences)

export function* getUserAfsLicences() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'getUserAfsLicences',
  action: actions,
  sagas: getUserAfsLicences,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUserAfsLicences: action.payload.afsLicences,
      isFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getUserAfsLicences.js